import { PropsWithChildren } from 'react'
 
type MessageErrorProps = {
  error?: string
}

export function MessageError({ error, children }: MessageErrorProps & PropsWithChildren) {
  return (
    <div className='flex flex-col gap-1'  >
      {children}
      {error && <p className="text-red-500 text-xs">{error}</p>}
    </div>
  )
}